import React from "react";

export default function FA4_Chart() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">FA4_Chart</h2>
      <p>Route: /icons/fa4/chart</p>
    </div>
  );
}
